<template>
  <el-collapse
    class="w-full h-auto rounded border border-gray-200 px-2 pb-2 bg-white shadow"
    :style="!fullHeight ? 'height: min-content !important;' : ''"
    v-model="activeNames"
  >
    <el-collapse-item class="border-b-0 pb-0" name="def">
      <template #title>
        <slot name="title"></slot>
        <h4 class="text-gray-600 px-2 leading-none" v-if="title">
          <i :class="icon" v-if="false"></i>
          {{ title }}
        </h4>
      </template>
      <div class="w-full h-full flex flex-col p-2 rounded border-gray-100">
        <slot />
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    fullHeight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeNames: 'def'
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style>
.el-collapse-item__content {
  padding-bottom: 0;
}
</style>
